import * as TYPES from './mutation-types'

export const setCheckedSettings = ({ commit }, settings) => {
    // Commit the mutations
    commit(TYPES.CAMPAING_CHECKED_SETTINGS, settings)
}


// WEBPACK FOOTER //
// ./src/app/adobeAcrobat/vuex/actions.js